<div
	color="accent"
	fxLayout
	fxLayoutAlign="space-between center"
	class="sub-toolbar"
>
	<h1 fxFlex class="mat-display-1 m-0 component-header">
		{{ title }}
	</h1>
	<div fxLayout fxLayoutGap="10px">
		<button
			[disabled]="isSaving"
			[class.shakeit]="invalidSubmission$ | async"
			mat-raised-button
			class="button save-button"
			(click)="saveAndStay()"
		>
			<span>
				<span *ngIf="!isSaving" fxLayout fxLayoutGap="5px">
					<mat-icon fxFlexAlign="center">save</mat-icon>
					Save
				</span>
				<span *ngIf="isSaving" fxLayout fxLayoutGap="5px">
					<mat-icon fxFlexAlign="center">save</mat-icon>
					Saving...
				</span>
			</span>
		</button>
		<button
			[disabled]="isSaving"
			[class.shakeit]="invalidSubmission$ | async"
			mat-raised-button
			class="button save-button"
			(click)="saveAndClose()"
		>
			<span>
				<span *ngIf="!isSaving" fxLayout fxLayoutGap="5px">
					<mat-icon fxFlexAlign="center">save</mat-icon>
					Save & Close
				</span>
				<span *ngIf="isSaving" fxLayout fxLayoutGap="5px">
					<mat-icon fxFlexAlign="center">save</mat-icon>
					Saving...
				</span>
			</span>
		</button>
		<button
			mat-raised-button
			class="button cancel-button"
			(click)="cancelAndClose()"
		>
			<mat-icon>close</mat-icon> Cancel & Close
		</button>
	</div>
</div>
